export default "__VITE_ASSET__DYVkJq_j__"